// const masterPlanLegendData = [
//     {
//         id: 1,
//         title: "Entrance Water Feature",
//         hotspots: [{ top: 92, left: 96.5 }],
//     },
//     {
//         id: 2,
//         title: "Driveway (Roads)",
//         hotspots: [
//             { top: 50, left: 83.5 },
//             { top: 50, left: 70 },
//             { top: 50, left: 55 },
//             { top: 44, left: 32 },
//             { top: 87, left: 95.5 },
//             { top: 65, left: 95 },
//             { top: 59, left: 43.3 },
//             { top: 22.2, left: 20 }
//         ],
//     },
//     {
//         id: 3,
//         title: "Boundary Plantation",
//         hotspots: [
//             { top: 57, left: 94.8 },
//             { top: 48, left: 77 },
//             { top: 1.5, left: 14.1 }
//         ],
//     },
//     {
//         id: 4,
//         title: "FootPath",
//         hotspots: [
//             { top: 70, left: 94.3 },
//             { top: 70, left: 82 },
//             { top: 50, left: 70 },
//             { top: 67.5, left: 54.5 },
//         ],
//     },
//     {
//         id: 5,
//         title: "Main Entrance Water Body",
//         hotspots: [{ top: 90, left: 93.8 }],
//     },
//     {
//         id: 6,
//         title: "Entrance Gateway",
//         hotspots: [{ top: 79, left: 95.5 }],
//     },
//     {
//         id: 7,
//         title: "Aqua Vista",
//         hotspots: [{ top: 56.8, left: 90.7 }],
//     },
//     {
//         id: 8,
//         title: "Tree Grove",
//         hotspots: [{ top: 62.5, left: 88.3 }],
//     },
//     {
//         id: 9,
//         title: "Pergola with Sculpture",
//         hotspots: [{ top: 78, left: 81.3 }],
//     },
//     {
//         id: 10,
//         title: "Gravel",
//         hotspots: [{ top: 67, left: 66.5 }],
//     },
//     {
//         id: 11,
//         title: "Seating",
//         hotspots: [
//             { top: 62.5, left: 65.2 },
//             { top: 53.5, left: 65.3 },
//             { top: 5.6, left: 27 },
//             { top: 44.5, left: 6.2 }
//         ],
//     },
//     {
//         id: 12,
//         title: "Planter Boxes",
//         hotspots: [
//             { top: 51.9, left: 61.8 },
//             { top: 47.9, left: 59 },
//         ],
//     },
//     {
//         id: 13,
//         title: "Pylons",
//         hotspots: [{ top: 47.9, left: 55.8 }],
//     },
//     {
//         id: 14,
//         title: "Pergola",
//         hotspots: [
//             { top: 72.2, left: 46.5 },
//             { top: 17, left: 36.7 },
//         ],
//     },
//     {
//         id: 15,
//         title: "Lawn",
//         hotspots: [
//             { top: 41.5, left: 52 },
//             { top: 16.9, left: 34.5 },
//             { top: 8.4, left: 30.2 },
//             { top: 47.8, left: 19.6 }
//         ],
//     },
//     {
//         id: 16,
//         title: "Pathway",
//         hotspots: [
//             { top: 70.1, left: 56.4 },
//             { top: 15, left: 34.9 },
//         ],
//     },
//     {
//         id: 17,
//         title: "Water Body",
//         hotspots: [{ top: 9.6, left: 31.5 }],
//     },
//     {
//         id: 18,
//         title: "Amphitheater",
//         hotspots: [{ top: 38.4, left: 49.6 }],
//     },
//     {
//         id: 19,
//         title: "Steps",
//         hotspots: [{ top: 35.9, left: 47.6 }],
//     },
//     {
//         id: 20,
//         title: "Pergola with Seating",
//         hotspots: [{ top: 34.7, left: 46.4 }],
//     },
//     {
//         id: 21,
//         title: "Multipurpose Court",
//         hotspots: [{ top: 35.7, left: 42.7 }],
//     },
//     {
//         id: 22,
//         title: "Climbing Wall",
//         hotspots: [{ top: 29.4, left: 41.5 }],
//     },
//     {
//         id: 23,
//         title: "EPDM Children’s Play Area",
//         hotspots: [{ top: 24.9, left: 41.9 }, { top: 42.6, left: 4.8 }],
//     },
//     {
//         id: 24,
//         title: "Mound",
//         hotspots: [{ top: 4, left: 28 }],
//     },
//     {
//         id: 25,
//         title: "Deck",
//         hotspots: [{ top: 18.2, left: 33.4 }],
//     },
//     {
//         id: 26,
//         title: "Water Body with Bubbles",
//         hotspots: [{ top: 81.7, left: 42.4 }],
//     },
//     {
//         id: 27,
//         title: "Pickleball Court",
//         hotspots: [
//             { top: 71.5, left: 28.4 },
//             { top: 75.5, left: 28.6 },
//         ],
//     },
//     {
//         id: 28,
//         title: "Cricket Pitch",
//         hotspots: [{ top: 68.3, left: 29.9 }],
//     },
//     {
//         id: 29,
//         title: "Water Body with Sculpture",
//         hotspots: [{ top: 52.3, left: 30 }],
//     },
// ];

// export default masterPlanLegendData;


const masterPlanLegendData = [
    { id: 1, title: "Entrance Water Feature", category: "water", icon: "💧", hotspots: [{ top: 8.5, left: 11.8 }] },

    {
        id: 2, title: "Driveway (Roads)", category: "infrastructure", icon: "🛣", hotspots: [
            { top: 13, left: 12.5 }, { top: 34.5, left: 13 }, { top: 48.6, left: 23.4 }, { top: 48.6, left: 35.8 }, { top: 48.6, left: 49.7 }, { top: 54.3, left: 70.8 }
            , { top: 39.9, left: 60.2 }, { top: 75.3, left: 81.8 }
        ]
    },

    {
        id: 3, title: "Boundary Plantation", category: "landscape", icon: "🌿", hotspots: [
            { top: 41.5, left: 13.2 }, { top: 50.5, left: 29.4 }, , { top: 95.5, left: 87 }
        ]
    },

    {
        id: 4, title: "FootPath", category: "infrastructure", icon: "🛣", hotspots: [
            { top: 29, left: 13.5 }, { top: 46.7, left: 38.2 }, { top: 32.4, left: 49.9 }, { top: 28.7, left: 24.9 }
        ]
    },

    { id: 5, title: "Main Entrance Water Body", category: "water", icon: "💧", hotspots: [{ top: 10.3, left: 14 }] },
    { id: 6, title: "Entrance Gateway", category: "infrastructure", icon: "🛣", hotspots: [{ top: 20, left: 12.6 }] },
    { id: 7, title: "Aqua Vista", category: "water", icon: "💧", hotspots: [{ top: 41.5, left: 17 }] },
    { id: 8, title: "Tree Grove", category: "landscape", icon: "🌿", hotspots: [{ top: 36, left: 19 }] },
    { id: 9, title: "Pergola with Sculpture", category: "amenities", icon: "🏀", hotspots: [{ top: 21.1, left: 25.5 }] },
    { id: 10, title: "Gravel", category: "landscape", icon: "🌿", hotspots: [{ top: 31.9, left: 39 }] },

    {
        id: 11, title: "Seating", category: "amenities", icon: "🏀", hotspots: [
            { top: 36.5, left: 40.5 }, { top: 44, left: 40 },{ top: 91.5, left: 75.3 },{ top: 53.8, left: 94.5}
        ]
    },

    {





        id: 12, title: "Planter Boxes", category: "landscape", icon: "🌿", hotspots: [
            { top: 46.5, left: 43.5 }, { top: 51, left: 46.2 }]
    },

    { id: 13, title: "Pylons", category: "infrastructure", icon: "🛣", hotspots: [{ top: 50.5, left: 49 }] },

    {
        id: 14, title: "Pergola", category: "amenities", icon: "🏀", hotspots: [
            { top: 31.9, left: 49.8 }, { top: 80.5, left: 66.2 }

        ]
    },

    {
        id: 15, title: "Lawn", category: "landscape", icon: "🌿", hotspots: [
            { top: 80.5, left: 68.4 }, { top: 88.5, left: 72.4 },{ top: 56.2, left: 52.5},{ top: 50, left: 82}]
    },

    {
        id: 16, title: "Pathway", category: "infrastructure", icon: "🛣", hotspots: [
            { top: 82, left: 68.3 }]
    },

    { id: 17, title: "Water Body", category: "water", icon: "💧", hotspots: [ { top: 87.5, left: 71.2 }] },
    { id: 18, title: "Amphitheater", category: "amenities", icon: "🏀", hotspots: [{ top: 60, left: 54.8}] },
    { id: 19, title: "Steps", category: "infrastructure", icon: "🛣", hotspots: [{ top: 62, left: 56.4}] },
    { id: 20, title: "Pergola with Seating", category: "amenities", icon: "🏀", hotspots: [{ top: 63, left: 57.6}] },
    { id: 21, title: "Multipurpose Court", category: "amenities", icon: "🏀", hotspots: [{ top: 35.7, left: 42.7 }] },
    { id: 22, title: "Climbing Wall", category: "amenities", icon: "🏀", hotspots: [{ top: 68.5, left: 62}] },
    { id: 23, title: "EPDM Children’s Play Area", category: "amenities", icon: "🏀", hotspots: [{ top: 72.8, left: 61.7}, { top: 55.8, left: 95.7}] },
    { id: 24, title: "Mound", category: "landscape", icon: "🌿", hotspots: [{ top: 92.8, left: 74.5}] },
    { id: 25, title: "Deck", category: "amenities", icon: "🏀", hotspots: [{ top: 78.8, left: 69.5}] },
    { id: 26, title: "Water Body with Bubbles", category: "water", icon: "💧", hotspots: [{ top: 17.7, left: 61.5 }] },
    { id: 27, title: "Pickleball Court", category: "amenities", icon: "🏀", hotspots: [{ top: 24.5, left: 73.9 }, { top: 27.5, left: 73.9 }] },
    { id: 28, title: "Cricket Pitch", category: "amenities", icon: "🏀", hotspots: [{ top: 30.5, left: 72.5 }] },
    { id: 29, title: "Water Body with Sculpture", category: "water", icon: "💧", hotspots: [{ top: 46.5, left: 72.5}] },
];

export default masterPlanLegendData;